import { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import UrlHelper from '../app/url_helper';

const NETWORK_FILTERS_KEY = 'ch.gatemedia:NETWORK_FILTERS_KEY';

$(document).on('ready turbolinks:load', () => {
  $('#filter-date').off('dp.change').on('dp.change', ({ currentTarget }) => {
    Turbolinks.visit(new UrlHelper(location.href)
      .urlByAppendingParams({ date: $(currentTarget).val() }));
  });

  $('[data-trigger-filter="true"]').off('change').change(({ currentTarget }) => {
    const $input = $(currentTarget);
    Turbolinks.visit(new UrlHelper(location.href)
      .urlByAppendingParams({ [$input.data('param')]: $input.is(':checked') }));
  });
});

export default class Filters extends Component {
  componentDidMount() {
    _.attempt(() => this.updateFilters());
    $('.grade-filter').off('change.filters').on('change.filters', () => this.updateGrades());
    $('.stop-filter').off('change.filters').on('change.filters', () => this.updateKinds());
    $('.time-filter').off('change.filters').on('change.filters', () => this.updateTimes());
  }

  componentWillUnmount() {
    $('.grade-filter').off('change.filters');
    $('.stop-filter').off('change.filters');
    $('.time-filter').off('change.filters');
  }

  onFiltersChanged() {
    const filters = { grades: this.grades, stopKinds: this.stopKinds, times: this.times };
    this.props.onFiltersChanged(filters);
    localStorage.setItem(NETWORK_FILTERS_KEY, JSON.stringify(filters));
  }

  updateFilters() {
    const filters = JSON.parse(localStorage.getItem(NETWORK_FILTERS_KEY));
    const $gradeFilters = $('.grade-filter');
    const $stopFilters = $('.stop-filter');
    const $timeFilters = $('.time-filter');

    this.grades = filters.grades || _.map($gradeFilters, el => $(el).data('value'));
    this.stopKinds = filters.stopKinds || _.map($stopFilters, el => $(el).data('value'));
    this.times = filters.times || _.map($timeFilters, el => $(el).data('param'));

    _.each($gradeFilters, el => $(el).attr('checked', _.includes(this.grades, $(el).data('value'))));
    _.each($stopFilters, el => $(el).attr('checked', _.includes(this.stopKinds, $(el).data('value'))));
    _.each($timeFilters, el => $(el).attr('checked', _.includes(this.times, $(el).data('param'))));
    this.onFiltersChanged();
  }

  updateGrades() {
    this.grades = _.map($('.grade-filter:checked'), el => $(el).data('value'));
    this.onFiltersChanged();
  }

  updateKinds() {
    this.stopKinds = _.map($('.stop-filter:checked'), el => $(el).data('value'));
    this.onFiltersChanged();
  }

  updateTimes() {
    this.times = _.map($('.time-filter:checked'), el => $(el).data('param'));
    this.onFiltersChanged();
  }

  render() {
    return null;
  }
}

Filters.propTypes = {
  onFiltersChanged: PropTypes.func.isRequired,
};
